export const grabAndGo = {
	searchPlaceholder: "Filtrar productos",
	activeProducts: "Productos activos para Grab and Go",
	disabledProducts: "Productos desactivados para Grab and Go",
};
